import React from 'react';

import { defineMessages, useIntl } from 'react-intl';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import rovoMobileAppOnelinkImage from '../../../assets/rovo-mobile-app-onelink.svg';

const messages = defineMessages({
	title: {
		id: 'ai-mate.chat-header.mobile-app-name',
		defaultMessage: 'Rovo app',
		description: 'Name of the Rovo mobile app shown in the more menu',
	},
	description: {
		id: 'ai-mate.chat-header.mobile-app-scan-description',
		defaultMessage: 'Scan QR code to use Rovo on the go',
		description: 'Description under the QR code in the mobile app sub-menu',
	},
	qrCodeAlt: {
		id: 'ai-mate.chat-header.mobile-app-qr-code-alt',
		defaultMessage: 'QR code to open Rovo mobile app',
		description: 'Accessible label for the QR code image in the mobile app sub-menu',
	},
});

const styles = cssMap({
	container: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		gap: token('space.100'),
		paddingTop: token('space.100'),
		paddingRight: token('space.200'),
		paddingBottom: token('space.100'),
		paddingLeft: token('space.200'),
	},
	qrCodeWrapper: {
		width: '160px',
		flexShrink: 0,
	},
	titleAndDescription: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		gap: token('space.050'),
		marginTop: token('space.050'),
		marginBottom: token('space.050'),
	},
	title: {
		font: token('font.body'),
		fontWeight: token('font.weight.medium'),
		color: token('color.text.subtle'),
		textAlign: 'center',
		marginTop: 0,
	},
	description: {
		font: token('font.body.small'),
		color: token('color.text.subtlest'),
		textAlign: 'center',
		marginTop: 0,
	},
});

export const MobileAppSubmenuContent = (): React.JSX.Element => {
	const { formatMessage } = useIntl();
	return (
		<Box xcss={styles.container}>
			<Box
				xcss={styles.qrCodeWrapper}
				as="img"
				src={rovoMobileAppOnelinkImage}
				alt={formatMessage(messages.qrCodeAlt)}
			/>
			<Box xcss={styles.titleAndDescription}>
				<Box as="p" xcss={styles.title}>
					{formatMessage(messages.title)}
				</Box>
				<Box as="p" xcss={styles.description}>
					{formatMessage(messages.description)}
				</Box>
			</Box>
		</Box>
	);
};
